export default __webpack_public_path__ + "static/media/khakibombshell2.0.84cb6933.jpg";